export default __webpack_public_path__ + "static/illistration3-c6b76cde40d7ac8e888e2da73968b0aa.png";